import { Link } from 'react-router-dom';
import { TextoDosTermos, VERSAO_DOS_TERMOS } from './TextoDosTermos';

/** `/termos` — pública: os termos que as contas criadas por pedido de acesso aceitam. */
const TermosPage = () => (
  <div className="min-h-screen bg-gray-50 py-16">
    <div className="container mx-auto px-4 max-w-3xl">
      <h1 className="font-titulo text-3xl font-bold text-tinta mb-2">Termos de uso</h1>
      <p className="text-sm text-gray-500 mb-8">Versão de {VERSAO_DOS_TERMOS.split('-').reverse().join('/')}</p>
      <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-8">
        <TextoDosTermos />
        <p className="mt-6 text-sm text-gray-500">
          Nas contas de demonstração, o item 2 é: "Esta é uma conta de demonstração, com dados fictícios; não cadastre
          alunos reais." Veja também a <Link to="/privacidade" className="text-marca-600 hover:underline">Política de Privacidade</Link>.
        </p>
      </div>
    </div>
  </div>
);

export default TermosPage;
